import _defineProperty from "/home/jenkins/workspace/tServices_Forms_Client_CICD_main/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _objectSpread from "/home/jenkins/workspace/tServices_Forms_Client_CICD_main/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import _objectWithoutProperties from "/home/jenkins/workspace/tServices_Forms_Client_CICD_main/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["as"],
    _excluded2 = ["freeInput", "multiselect"],
    _excluded3 = ["disabled", "required", "className", "error", "hideLabel", "label", "defaultOpen", "open", "onOpenChange", "onFocus", "onBlur", "defaultInputValue", "inputValue", "onInputValueChange", "defaultValue", "value", "onValueChange", "displayValue", "displayAvatar", "displayTooltip", "hideOnEscape", "renderOption", "options", "filterFn", "loading", "loadingAriaLabel", "noResultMessage", "clearOnBlur", "clearOnEscape", "portalElement", "hideSelectedOptions", "unmountOnHide", "experimentalVirtualization", "getPopoverRef", "focusLoop", "clearButtonAriaLabel", "endComboboxIcon", "idForLabel"],
    _excluded4 = ["children", "value", "disabled", "className"],
    _excluded5 = ["children", "className"];
import { jsx, jsxs, Fragment } from 'react/jsx-runtime';
import { SelectItemCheck, SelectItem, ComboboxItem, useComboboxStore, useSelectStore, PopoverAnchor, Combobox as Combobox$1, ComboboxCancel, SelectList, ComboboxPopover } from '@ariakit/react';
import { SelectRenderer } from '@ariakit/react-core/select/select-renderer';
import { Checkmark, XMark } from '@box/blueprint-web-assets/icons/Fill';
import clsx from 'clsx';
import React__default, { forwardRef, useMemo, useRef, useCallback, useEffect } from 'react';
import { InputChip } from '../input-chip/input-chip.js';
import { LoadingIndicator } from '../loading-indicator/loading-indicator.js';
import { IconButton } from '../primitives/icon-button/icon-button.js';
import { InlineError } from '../primitives/inline-error/inline-error.js';
import { TextArea } from '../text-area/text-area.js';
import { useLabelable } from '../util-components/labelable/useLabelable.js';
import { composeEventHandlers } from '../utils/composeEventHandlers.js';
import { useForkRef } from '../utils/useForkRef.js';
import { useUniqueId } from '../utils/useUniqueId.js';
import { ChipsGroup } from './chips-group.js';
import styles from './combobox.module.js';

var getOptionValue = function getOptionValue(option) {
  return typeof option === 'string' ? option : option.value;
};

var getOptionFromValue = function getOptionFromValue(value, options) {
  return options.find(function (option) {
    return typeof option === 'string' ? option === value : option.value === value;
  });
};

var getDisplayValueFromOptionValue = function getDisplayValueFromOptionValue(optionValue, options, displayValue) {
  var option = getOptionFromValue(optionValue, options);
  return displayValue && option ? displayValue(option) : optionValue;
};

var getDisplayAvatarFromOptionValue = function getDisplayAvatarFromOptionValue(optionValue, options, displayAvatar) {
  var option = getOptionFromValue(optionValue, options);
  return displayAvatar && option ? displayAvatar(option) : undefined;
};

var getTooltipValueFromOptionValue = function getTooltipValueFromOptionValue(optionValue, options, displayTooltip) {
  var option = getOptionFromValue(optionValue, options);
  return displayTooltip && option ? displayTooltip(option) : undefined;
};

var RootInner = function RootInner(_ref, ref) {
  var _clsx3;

  var _ref$as = _ref.as,
      as = _ref$as === void 0 ? 'input' : _ref$as,
      props = _objectWithoutProperties(_ref, _excluded);

  var _props$freeInput = props.freeInput,
      freeInput = _props$freeInput === void 0 ? false : _props$freeInput,
      _props$multiselect = props.multiselect,
      multiselect = _props$multiselect === void 0 ? false : _props$multiselect,
      rest = _objectWithoutProperties(props, _excluded2);

  var _rest$disabled = rest.disabled,
      disabled = _rest$disabled === void 0 ? false : _rest$disabled,
      _rest$required = rest.required,
      required = _rest$required === void 0 ? false : _rest$required,
      className = rest.className,
      error = rest.error,
      _rest$hideLabel = rest.hideLabel,
      hideLabel = _rest$hideLabel === void 0 ? false : _rest$hideLabel,
      label = rest.label,
      _rest$defaultOpen = rest.defaultOpen,
      defaultOpen = _rest$defaultOpen === void 0 ? false : _rest$defaultOpen,
      open = rest.open,
      onOpenChange = rest.onOpenChange,
      onFocus = rest.onFocus,
      onBlur = rest.onBlur,
      _rest$defaultInputVal = rest.defaultInputValue,
      defaultInputValue = _rest$defaultInputVal === void 0 ? '' : _rest$defaultInputVal,
      inputValueProp = rest.inputValue,
      onInputValueChange = rest.onInputValueChange,
      defaultValue = rest.defaultValue,
      valueProp = rest.value,
      onValueChange = rest.onValueChange,
      displayValue = rest.displayValue,
      displayAvatar = rest.displayAvatar,
      displayTooltip = rest.displayTooltip,
      hideOnEscape = rest.hideOnEscape,
      renderOption = rest.renderOption,
      options = rest.options,
      filterFn = rest.filterFn,
      _rest$loading = rest.loading,
      loading = _rest$loading === void 0 ? false : _rest$loading,
      _rest$loadingAriaLabe = rest.loadingAriaLabel,
      loadingAriaLabel = _rest$loadingAriaLabe === void 0 ? '' : _rest$loadingAriaLabe,
      _rest$noResultMessage = rest.noResultMessage,
      noResultMessage = _rest$noResultMessage === void 0 ? '' : _rest$noResultMessage,
      _rest$clearOnBlur = rest.clearOnBlur,
      clearOnBlur = _rest$clearOnBlur === void 0 ? !freeInput : _rest$clearOnBlur,
      _rest$clearOnEscape = rest.clearOnEscape,
      clearOnEscape = _rest$clearOnEscape === void 0 ? false : _rest$clearOnEscape,
      portalElement = rest.portalElement,
      _rest$hideSelectedOpt = rest.hideSelectedOptions,
      hideSelectedOptions = _rest$hideSelectedOpt === void 0 ? false : _rest$hideSelectedOpt,
      _rest$unmountOnHide = rest.unmountOnHide,
      unmountOnHide = _rest$unmountOnHide === void 0 ? false : _rest$unmountOnHide,
      _rest$experimentalVir = rest.experimentalVirtualization,
      experimentalVirtualization = _rest$experimentalVir === void 0 ? false : _rest$experimentalVir,
      getPopoverRef = rest.getPopoverRef,
      focusLoop = rest.focusLoop,
      clearButtonAriaLabel = rest.clearButtonAriaLabel,
      endComboboxIcon = rest.endComboboxIcon,
      idForLabel = rest.idForLabel,
      comboboxProps = _objectWithoutProperties(rest, _excluded3);

  var isInput = useMemo(function () {
    return as === 'input';
  }, [as]);
  var inputRef = useRef(null);
  var comboboxId = useUniqueId('combobox-', !idForLabel) || idForLabel || 'default-combobox-id';
  var popoverRef = useRef(null);
  var comboboxContainerRef = useRef(null);
  var popoverRefCallback = useCallback(function (node) {
    popoverRef.current = node;
    getPopoverRef === null || getPopoverRef === void 0 ? void 0 : getPopoverRef(node);
  }, [getPopoverRef]);
  var hasError = !!error && !disabled;
  var comboboxStore = useComboboxStore({
    // Input state
    defaultValue: defaultInputValue,
    value: inputValueProp,
    setValue: onInputValueChange,
    // Open state
    defaultOpen: defaultOpen && !disabled,
    open: open && !disabled,
    setOpen: onOpenChange,
    includesBaseElement: true,
    virtualFocus: false,
    focusLoop: focusLoop
  });
  var setInputValue = comboboxStore.setValue,
      setOpen = comboboxStore.setOpen;
  var inputValue = comboboxStore.useState('value');
  var isOpen = comboboxStore.useState('open');
  var getSelectedOptionValues = useCallback(function (valueSource) {
    return Array.isArray(valueSource) ? valueSource.map(function (val) {
      return getOptionValue(val);
    }) : getOptionValue(valueSource);
  }, []);

  var getDefaultValue = function getDefaultValue() {
    /**
     * It's necessary to explicitly set the defaultValue to an empty array
     * when multiselect is true but no defaultValue is specified. Otherwise,
     * Ariakit won't know that we want to have a multi-selectable combobox.
     */
    if (defaultValue == null) {
      return multiselect ? [] : '';
    }

    return getSelectedOptionValues(defaultValue);
  };

  var initSelectValue = useMemo(function () {
    if (valueProp == null) {
      return undefined;
    }

    return getSelectedOptionValues(valueProp);
  }, [getSelectedOptionValues, valueProp]);

  var setValue = function setValue(newSelectedValue) {
    if (!onValueChange) {
      return;
    }

    var selectedOption;

    if (Array.isArray(newSelectedValue)) {
      selectedOption = newSelectedValue.map(function (newValue) {
        return getOptionFromValue(newValue, options);
      });
    } else {
      selectedOption = getOptionFromValue(newSelectedValue, options);
    }

    onValueChange(selectedOption);
  };

  var selectStore = useSelectStore({
    combobox: comboboxStore,
    defaultValue: getDefaultValue(),
    value: initSelectValue,
    setValue: setValue
  });
  var selectedValue = selectStore.useState('value');
  var setSelectedValue = selectStore.setValue;
  var resetSelectedValue = useCallback(function () {
    setSelectedValue(multiselect ? [] : '');
  }, [multiselect, setSelectedValue]);
  var filteredOptions = useMemo(function () {
    var visibleOptions = filterFn ? options.filter(function (option) {
      return filterFn(inputValue, option);
    }) : options;

    if (!hideSelectedOptions) {
      return visibleOptions;
    }

    return visibleOptions.filter(function (option) {
      return !selectedValue.includes(getOptionValue(option));
    });
  }, [filterFn, options, hideSelectedOptions, inputValue, selectedValue]);
  var focusInput = useCallback(function () {
    var _inputRef$current;

    (_inputRef$current = inputRef.current) === null || _inputRef$current === void 0 ? void 0 : _inputRef$current.focus();
  }, []);
  var renderSelectItemOption = useCallback(function (option) {
    var value = getOptionValue(option);
    return jsxs(OptionWithIndicator, _objectSpread(_objectSpread({}, typeof option === 'object' ? option : {}), {}, {
      disabled: typeof option === 'object' && option.disabled,
      value: value,
      children: [jsx(Indicator, {}), displayValue ? displayValue(option) : value]
    }));
  }, [displayValue]);
  var renderOptionFn = renderOption || renderSelectItemOption; // eslint-disable-next-line react-hooks/exhaustive-deps

  var selectedValueMemoized = useMemo(function () {
    return selectedValue;
  }, [JSON.stringify(selectedValue)]); // Reset input whenever an option is checked or unchecked

  useEffect(function () {
    if (Array.isArray(selectedValueMemoized) || showSingleSelectChip) {
      setInputValue('');
    } else if (selectedValueMemoized) {
      setInputValue(getDisplayValueFromOptionValue(selectedValueMemoized, options, displayValue)); // Also focus input for single-select variant

      focusInput();
    }
  }, // eslint-disable-next-line react-hooks/exhaustive-deps
  [selectedValueMemoized, setInputValue, focusInput]);
  var handleKeyDown = useCallback(function (event) {
    // Close menu
    if (event.key === 'Enter' || event.key === 'Tab') {
      if (event.nativeEvent.isComposing) {
        return;
      }

      setOpen(false);
      return;
    } // Close menu or clear input


    if (event.key === 'Escape') {
      if (isOpen) {
        setOpen(false);
      } else {
        if (!clearOnEscape) {
          return;
        }

        setInputValue('');
        resetSelectedValue();
      }
    }
  }, [clearOnEscape, isOpen, resetSelectedValue, setInputValue, setOpen]); // Reset input on blur

  var handleOnBlur = useCallback(function () {
    if (!clearOnBlur || isOpen) {
      return;
    }

    setInputValue(Array.isArray(selectedValue) || showSingleSelectChip ? '' : getDisplayValueFromOptionValue(selectedValue, options, displayValue));
  }, // eslint-disable-next-line react-hooks/exhaustive-deps
  [clearOnBlur, isOpen, selectedValue, setInputValue]);
  var handleOnFocus = useCallback(function (event) {
    onFocus === null || onFocus === void 0 ? void 0 : onFocus(event);
  }, [onFocus]);

  var removeMultiSelectInputChip = function removeMultiSelectInputChip(id) {
    // For multi-select variant only
    selectStore.setValue(function (prev) {
      if (Array.isArray(prev)) {
        // unselect corresponding option
        var remainingValues = prev.filter(function (val) {
          return val !== id;
        }); // focus combobox input if no more input chips

        if (remainingValues.length === 0) {
          focusInput();
        } // update state


        return remainingValues;
      } // do nothing it single-select


      return prev;
    });
  };

  var handleFocusInputOnEvent = useCallback(function (event) {
    // don't focus if child element event was triggered
    if (event.target !== event.currentTarget) {
      return;
    }

    focusInput();
  }, [focusInput]);

  var removeSingleSelectInputChip = function removeSingleSelectInputChip() {
    resetSelectedValue();
    focusInput();
  };

  var reference = useForkRef(inputRef, ref);
  var showChipsGroup = Array.isArray(selectedValue) && selectedValue.length > 0;
  var showComboboxCancelButton = clearButtonAriaLabel && (inputValue.length > 0 || (Array.isArray(selectedValue) ? selectedValue.length > 0 : !!selectedValue));
  var showSingleSelectChip = showComboboxCancelButton && !Array.isArray(selectedValue) && !!selectedValue;
  var Label = useLabelable(label, comboboxId);
  var inlineErrorId = useUniqueId('inline-error-');
  var ariaDescribedBy = clsx(rest['aria-describedby'], _defineProperty({}, inlineErrorId, hasError));
  var inputComponent = isInput ? jsxs(Fragment, {
    children: [jsx(Label, {
      className: clsx(styles.label, _defineProperty({}, styles.hiddenLabel, hideLabel)),
      hideLabel: hideLabel
    }), jsx(PopoverAnchor, {
      store: comboboxStore,
      children: jsxs("div", {
        ref: comboboxContainerRef,
        className: clsx(styles.comboboxContainer, (_clsx3 = {}, _defineProperty(_clsx3, styles.error, hasError), _defineProperty(_clsx3, styles.withChips, showChipsGroup || showSingleSelectChip), _defineProperty(_clsx3, styles.withComboboxButtons, showComboboxCancelButton || Boolean(endComboboxIcon)), _clsx3)),
        "data-testid": "combobox-container",
        onClick: handleFocusInputOnEvent,
        children: [showChipsGroup && jsx(ChipsGroup, {
          onClick: handleFocusInputOnEvent,
          children: selectedValue.map(function (selected) {
            return jsx(InputChip, {
              avatar: getDisplayAvatarFromOptionValue(selected, options, displayAvatar),
              label: getDisplayValueFromOptionValue(selected, options, displayValue),
              onDelete: function onDelete() {
                return removeMultiSelectInputChip(selected);
              },
              tooltip: getTooltipValueFromOptionValue(selected, options, displayTooltip)
            }, selected);
          })
        }), showSingleSelectChip && jsx(InputChip, {
          label: getDisplayValueFromOptionValue(selectedValue, options, displayValue),
          onDelete: showComboboxCancelButton ? undefined : removeSingleSelectInputChip,
          tooltip: getTooltipValueFromOptionValue(selectedValue, options, displayTooltip)
        }), jsxs("div", {
          className: styles.textInputWrapper,
          children: [jsx(Combobox$1, _objectSpread(_objectSpread(_objectSpread({}, comboboxProps), {}, {
            ref: reference,
            "aria-describedby": ariaDescribedBy
          }, hasError && {
            'aria-invalid': 'true'
          }), {}, {
            "aria-required": required,
            autoSelect: false,
            className: styles.textInput,
            disabled: disabled,
            id: comboboxId,
            onBlur: composeEventHandlers(onBlur, handleOnBlur),
            onFocus: handleOnFocus,
            onKeyDown: handleKeyDown,
            required: required,
            store: comboboxStore
          })), jsx("div", {
            className: styles.comboboxButtons,
            children: showComboboxCancelButton ? jsx(ComboboxCancel, {
              onClick: resetSelectedValue,
              // eslint-disable-next-line react/jsx-no-bind
              render: function render(cancelProps) {
                return jsx(IconButton, _objectSpread(_objectSpread({}, cancelProps), {}, {
                  "aria-label": clearButtonAriaLabel,
                  icon: XMark,
                  size: "x-small"
                }));
              },
              store: comboboxStore
            }) : endComboboxIcon
          })]
        })]
      })
    }), jsx(InlineError, {
      className: styles.inlineError,
      id: inlineErrorId,
      children: error
    })]
  }) : jsx(Combobox$1, _objectSpread(_objectSpread({}, comboboxProps), {}, {
    autoSelect: false,
    id: comboboxId,
    render: jsx(TextArea, _objectSpread(_objectSpread({
      ref: reference
    }, hasError && {
      'aria-invalid': 'true'
    }), {}, {
      "aria-required": required,
      className: styles.textInput,
      disabled: disabled,
      error: error,
      hideLabel: hideLabel,
      label: label,
      onBlur: composeEventHandlers(onBlur, handleOnBlur),
      onFocus: handleOnFocus,
      onKeyDown: handleKeyDown,
      required: required
    })),
    store: comboboxStore
  }));
  var render = useCallback(function (popoverProps) {
    return jsx(SelectList, _objectSpread(_objectSpread({}, popoverProps), {}, {
      "aria-multiselectable": true,
      // Disable the composite behavior on the select list since combobox will handle it
      composite: false,
      store: selectStore,
      // Disable typeahead so it doesn't conflict with typing on the combobox input
      typeahead: false
    }));
  }, [selectStore]);
  var showLoading = loading && !!loadingAriaLabel;
  return jsxs("div", {
    className: clsx(styles.container, _defineProperty({}, styles.disabled, disabled), className),
    children: [inputComponent, showLoading || filteredOptions.length > 0 || filteredOptions.length <= 0 && noResultMessage ? jsx(ComboboxPopover, {
      ref: popoverRefCallback,
      "aria-labelledby": comboboxId,
      className: styles.popover,
      fitViewport: true,
      gutter: 8,
      hideOnEscape: hideOnEscape,
      portal: true,
      portalElement: portalElement,
      render: render,
      sameWidth: true,
      store: comboboxStore,
      unmountOnHide: unmountOnHide,
      children: jsx(Collection, {
        experimentalVirtualization: experimentalVirtualization,
        inputValue: inputValue,
        loadingAriaLabel: loadingAriaLabel,
        noResultMessage: noResultMessage,
        options: filteredOptions,
        overscan: 2,
        renderOptionFn: renderOptionFn,
        showLoading: showLoading
      })
    }) : null]
  });
};

var Root = /*#__PURE__*/forwardRef(RootInner);
var Indicator = /*#__PURE__*/forwardRef(function (_, ref) {
  return jsx(SelectItemCheck, {
    ref: ref,
    className: styles.indicator,
    // Remove width and height styles to unset values from Ariakit
    style: {
      width: 'none',
      height: 'none'
    },
    children: jsx(Checkmark, {
      className: styles.indicatorIcon
    })
  });
});
Indicator.displayName = 'Combobox.Indicator';
var Option = /*#__PURE__*/forwardRef(function (props, ref) {
  var children = props.children,
      value = props.value,
      disabled = props.disabled,
      className = props.className,
      rest = _objectWithoutProperties(props, _excluded4);

  return jsx(SelectItem, _objectSpread({
    ref: ref,
    autoFocus: false,
    className: clsx(styles.option, className),
    disabled: disabled,
    focusOnHover: false,

    /* eslint-disable react/jsx-no-bind */
    render: function render(itemProps) {
      return jsx(ComboboxItem, _objectSpread(_objectSpread({}, itemProps), {}, {
        disabled: disabled,
        children: children
      }));
    },
    value: value
  }, rest));
});
Option.displayName = 'Combobox.Option';
var OptionWithIndicator = /*#__PURE__*/forwardRef(function (props, ref) {
  var children = props.children,
      className = props.className,
      optionProps = _objectWithoutProperties(props, _excluded5);

  return jsxs(Option, _objectSpread(_objectSpread({
    ref: ref
  }, optionProps), {}, {
    className: clsx(styles.optionWithIndicator, className),
    children: [jsx(Indicator, {}), children]
  }));
});
OptionWithIndicator.displayName = 'Combobox.OptionWithIndicator';
var Combobox = Object.assign(Root, {
  Option: Option,
  OptionWithIndicator: OptionWithIndicator,
  Indicator: Indicator
});

var Collection = function Collection(_ref2) {
  var options = _ref2.options,
      experimentalVirtualization = _ref2.experimentalVirtualization,
      renderOptionFn = _ref2.renderOptionFn,
      inputValue = _ref2.inputValue,
      _ref2$noResultMessage = _ref2.noResultMessage,
      noResultMessage = _ref2$noResultMessage === void 0 ? '' : _ref2$noResultMessage,
      overscan = _ref2.overscan,
      showLoading = _ref2.showLoading,
      loadingAriaLabel = _ref2.loadingAriaLabel;
  var resultsFound = options.length > 0;

  if (showLoading) {
    return jsx(Option, {
      disabled: true,
      children: jsx(LoadingIndicator, {
        "aria-label": loadingAriaLabel,
        className: styles.loadingIndicator
      })
    });
  }

  if (resultsFound) {
    return experimentalVirtualization ? jsx(SelectRenderer, {
      id: "collection-renderer" // without id, combobox crashes with prop defaultOpen={true}
      ,
      items: options,
      overscan: overscan,
      children: function children(option) {
        var key = getOptionValue(option);
        return jsx(React__default.Fragment, {
          children: // eslint-disable-next-line @typescript-eslint/no-explicit-any
          renderOptionFn(option)
        }, key);
      }
    }, inputValue) : jsx(Fragment, {
      children: options.map(function (option) {
        return jsx(React__default.Fragment, {
          children: renderOptionFn(option)
        }, typeof option === 'string' ? option : option.value);
      })
    });
  }

  return typeof noResultMessage === 'string' ? jsx(Option, {
    disabled: true,
    children: noResultMessage
  }) : noResultMessage;
};

export { Combobox, Root };